import enhancer from './Sidebar.hoc'
import Sidebar from './Sidebar'

export default enhancer(Sidebar)
